import { render, staticRenderFns } from "./termDialog.vue?vue&type=template&id=f9cf4b38&scoped=true&"
import script from "./termDialog.vue?vue&type=script&lang=js&"
export * from "./termDialog.vue?vue&type=script&lang=js&"
import style0 from "./termDialog.vue?vue&type=style&index=0&id=f9cf4b38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cf4b38",
  null
  
)

export default component.exports